import { t } from '@lingui/core/macro'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

export type StatusConfig = {
  icon: React.ElementType
  muiColor: 'warning' | 'success'
  label: string
}

export function getStatusConfig(status: string): StatusConfig {
  const normalized = status.toLowerCase()
  const map: Record<string, StatusConfig> = {
    submitted: { icon: AccessTimeIcon, muiColor: 'warning', label: t`Submitted` },
    resolved: { icon: CheckCircleIcon, muiColor: 'success', label: t`Resolved` },
  }
  return map[normalized] || map.submitted
}

export function isResponseVisible(status: string): boolean {
  return status.toLowerCase() === 'resolved'
}
